mutation InvoiceUploadDocument(
  $document: DocumentUploadInput!
  $invoiceId: UUID!
) {
  invoiceUploadDocument(document: $document, invoiceId: $invoiceId) {
    uploadLink
    document {
      _documentFileId
      invoiceDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
        _isStagedApprovalRequest
      }
    }
  }
}
